import React from 'react';
import PropTypes from 'prop-types';
import { InputGroup, Form, Image } from 'react-bootstrap';
import { isEmptyThenTo, isEmptyPropertyThenTo } from 'y4/Utils';
import DynamicSelect from './DynamicSelect';
import FileUpload from './FileUpload';
import ImageUpload from './ImageUpload';
import { Link } from 'react-router-dom';

const FormItem = ({ dataCode, field, row, onChange, eventTarget }) => {
  if (field.type == 'Boolean') {
    return (
      <InputGroup.Text>
        <Form.Check
          id={field.name}
          name={field.name + 'Ui'}
          className="mb-0"
          type="checkbox"
          onChange={onChange}
          label=""
          checked={isEmptyThenTo(row[field.name + 'Ui'], false)}
          disabled={field.readonly}
        />
      </InputGroup.Text>
    );
  } else {
    if (field.extraType == 'Quote' || field.extraType == 'BrieflyCode') {
      return (
        <DynamicSelect
          dataCode={dataCode}
          id={field.name}
          name={field.name + 'Ui'}
          field={field}
          row={row}
          onChange={onChange}
          eventTarget={eventTarget}
        />
      );
    } else if (field.extraType == 'Image') {
      if (field.readonly) {
        const i = isEmptyThenTo(row[field.name + 'Ui'], '');
        return <Image src={i} thumbnail />;
      } else {
        return (
          <ImageUpload
            id={field.name}
            name={field.name + 'Ui'}
            field={field}
            row={row}
            dataCode={dataCode}
            onChange={onChange}
          />
        );
      }
    } else if (field.extraType == 'File') {
      if (field.readonly) {
        const i = isEmptyThenTo(row[field.name + 'Ui'], '');
        return <Link to={i}>{i}</Link>;
      } else {
        return (
          <FileUpload
            id={field.name}
            name={field.name + 'Ui'}
            field={field}
            row={row}
            dataCode={dataCode}
            onChange={onChange}
          />
        );
      }
    } else if (field.extraType == 'Label') {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: isEmptyThenTo(row[field.name + 'Ui'], '')
          }}
        ></div>
      );
    } else if (field.multipleLine) {
      return (
        <Form.Control
          id={field.name}
          name={field.name + 'Ui'}
          value={isEmptyThenTo(row[field.name + 'Ui'], '')}
          placeholder={field.valueTip}
          aria-label={field.name + 'Label'}
          onChange={onChange}
          disabled={field.readonly}
          rows={isEmptyPropertyThenTo(field, 'other.textRows', 10)}
          as="textarea"
        />
      );
    } else {
      return (
        <Form.Control
          required={field.required}
          id={field.name}
          name={field.name + 'Ui'}
          value={isEmptyThenTo(row[field.name + 'Ui'], '')}
          placeholder={field.valueTip}
          aria-label={field.name + 'Label'}
          onChange={onChange}
          disabled={field.readonly}
        />
      );
    }
  }
};

FormItem.propTypes = {
  dataCode: PropTypes.string,
  row: PropTypes.object,
  field: PropTypes.object,
  onChange: PropTypes.func,
  eventTarget: PropTypes.object
};

export default FormItem;
